import { render, staticRenderFns } from "./SecondaryMenu.vue?vue&type=template&id=18c7a31e"
import script from "./SecondaryMenu.vue?vue&type=script&lang=js"
export * from "./SecondaryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports